'use client';

import Image from 'next/image';

const SOCIAL_LINKS = [
  {
    href: 'https://pro.kudoswall.com/',
    src: '/resume-examples-assets/assets/images/social/kw.png',
    alt: 'KudosWall',
  },
  {
    href: 'https://www.facebook.com/kudoswall',
    src: '/resume-examples-assets/assets/images/social/facebook.svg',
    alt: 'Facebook',
  },
  {
    href: 'https://www.instagram.com/kudoswall',
    src: '/resume-examples-assets/assets/images/social/instagram.svg',
    alt: 'Instagram',
  },
  {
    href: 'https://www.linkedin.com/company/kudoswall',
    src: '/resume-examples-assets/assets/images/social/linkedin.svg',
    alt: 'LinkedIn',
  },
  {
    href: 'https://t.me/careerprep',
    src: '/resume-examples-assets/assets/images/social/telegram.svg',
    alt: 'Telegram',
  },
  {
    href: 'https://youtube.com/@AIResumeBuilder',
    src: '/resume-examples-assets/assets/images/social/youtube.svg',
    alt: 'YouTube',
  },
] as const;

const sidebarStyle: React.CSSProperties = {
  position: 'fixed',
  top: '50%',
  right: '40px',
  transform: 'translateY(-50%)',
  zIndex: 1000,
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
};

const linkStyle: React.CSSProperties = {
  display: 'block',
};

const imgStyle: React.CSSProperties = {
  width: '40px',
  height: '40px',
  transition: 'transform 0.3s ease',
};

export function SocialSidebar() {
  return (
    <>
      <style>{`
        .social-sidebar-link img:hover {
          transform: scale(1.1);
        }
        @media (max-width: 767px) {
          .social-sidebar {
            display: none !important;
          }
        }
      `}</style>
      <div className="social-sidebar" style={sidebarStyle}>
        {SOCIAL_LINKS.map((link) => (
          <a
            key={link.alt}
            href={link.href}
            target="_blank"
            rel="noopener noreferrer"
            className="social-sidebar-link"
            style={linkStyle}
          >
            <Image
              src={link.src}
              alt={link.alt}
              width={40}
              height={40}
              unoptimized
              style={imgStyle}
            />
          </a>
        ))}
      </div>
    </>
  );
}
